import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AuthenticationFailedAction = {
	type: 'AUTHENTICATION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AuthenticationFailedAction => ({
	type: 'AUTHENTICATION_FAILED',
	payload,
});
